'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useAppliedTheme } from '@/hooks/ui/use-applied-theme';
import { env } from '@/lib/config/env';
import { cn } from '@/lib/ui/utils';
import { LOGO_BETA_SRC_DARK_BACKGROUND, LOGO_BETA_SRC_LIGHT_BACKGROUND, LOGO_SRC_DARK_BACKGROUND, LOGO_SRC_LIGHT_BACKGROUND, logoBetaWidthForHeight, logoWordmarkWidthForHeight, O_MARK_SRC_DARK_BACKGROUND, O_MARK_SRC_LIGHT_BACKGROUND } from './constants';
const DEFAULT_LOGO_HEIGHT_PX = 64;
interface MorfiLogoProps {
  /** Logo height in pixels. Width follows the active asset aspect ratio. Default 64. */
  size?: number;
  mark?: boolean;
  className?: string;
}
function isBetaLockupEnabled(): boolean {
  return env.NEXT_PUBLIC_EARLY_ACCESS_ENABLED === 'true';
}
function resolveLogoSrc(theme: 'light' | 'dark' | undefined, beta: boolean, mark: boolean): string {
  if (mark) {
    return theme === 'dark' ? O_MARK_SRC_DARK_BACKGROUND : O_MARK_SRC_LIGHT_BACKGROUND;
  }
  if (beta) {
    return theme === 'dark' ? LOGO_BETA_SRC_DARK_BACKGROUND : LOGO_BETA_SRC_LIGHT_BACKGROUND;
  }
  return theme === 'dark' ? LOGO_SRC_DARK_BACKGROUND : LOGO_SRC_LIGHT_BACKGROUND;
}
export function MorfiLogo(t0) {
  const $ = _c(15);
  const {
    size: t1,
    mark: t2,
    className
  } = t0;
  const size = t1 === undefined ? DEFAULT_LOGO_HEIGHT_PX : t1;
  const mark = t2 === undefined ? false : t2;
  const theme = useAppliedTheme();
  let beta;
  let height;
  let t3;
  let width;
  if ($[0] !== mark || $[1] !== size || $[2] !== theme) {
    beta = isBetaLockupEnabled();
    height = size;
    width = mark ? size : beta ? logoBetaWidthForHeight(size) : logoWordmarkWidthForHeight(size);
    t3 = resolveLogoSrc(theme, beta, mark);
    $[0] = mark;
    $[1] = size;
    $[2] = theme;
    $[3] = beta;
    $[4] = height;
    $[5] = t3;
    $[6] = width;
  } else {
    beta = $[3];
    height = $[4];
    t3 = $[5];
    width = $[6];
  }
  const src = t3;
  const t4 = mark ? "Morfi" : beta ? "Morfi Beta" : "Morfi";
  let t5;
  if ($[7] !== className) {
    t5 = cn("block shrink-0 object-contain", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== height || $[10] !== src || $[11] !== t4 || $[12] !== t5 || $[13] !== width) {
    t6 = <Image src={src} alt={t4} width={width} height={height} className={t5} />;
    $[9] = height;
    $[10] = src;
    $[11] = t4;
    $[12] = t5;
    $[13] = width;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}